import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player/lazy";

interface Props {
  videoUrl: string;
  posterUrl?: string;
}

const IphonePlayer: React.FC<Props> = ({ videoUrl, posterUrl }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const playerRef = useRef<ReactPlayer>(null);

  // Определяем, является ли устройство мобильным

  // Эффект для обработки задержки загрузки
  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      if (isLoading && ready) {
        // Если загрузка занимает слишком много времени, но плеер готов
        setIsLoading(false);
      }
    }, 3000);

    return () => clearTimeout(loadingTimeout);
  }, [isLoading, ready]);

  // Обработчик для переключения воспроизведения
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  // Обработчики для React Player
  const handleReady = () => {
    console.log("Player is ready");
    setReady(true);
    setIsLoading(false);
  };

  const handleStart = () => {
    console.log("Video started playing");
    setIsPlaying(true);
    setIsLoading(false);
  };

  const handleError = (error: any) => {
    console.error("Video error:", error);
    setIsLoading(false);
  };

  const handleBuffer = () => {
    console.log("Video buffering");
    setIsLoading(true);
  };

  const handleBufferEnd = () => {
    console.log("Video buffering ended");
    setIsLoading(false);
  };

  return (
    <div className="flex items-center justify-center w-full h-auto">
      <div className="relative w-full h-auto mx-auto">
        {/* iPhone background image */}
        <img
          src="/images/phone.webp"
          alt="iPhone frame"
          className="w-full h-auto object-contain"
        />

        {/* Screen positioned over the image */}
        <div
          className="absolute overflow-hidden z-10 bg-black"
          style={{
            top: "12%",
            left: "8%",
            width: "84%",
            height: "76%",
            borderRadius: "4px",
          }}
        >
          {/* Индикатор загрузки */}
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-20">
              <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          )}

          {/* React Player вместо стандартного video */}
          <div className="w-full h-full" onClick={togglePlay}>
            <ReactPlayer
              ref={playerRef}
              url={videoUrl}
              width="100%"
              height="100%"
              playing={isPlaying}
              playsinline
              muted
              config={{
                file: {
                  attributes: {
                    poster: posterUrl,
                    preload: "auto",
                    controlsList: "nodownload",
                  },
                  forceVideo: true,
                },
              }}
              progressInterval={500}
              onReady={handleReady}
              onStart={handleStart}
              onError={handleError}
              onBuffer={handleBuffer}
              onBufferEnd={handleBufferEnd}
              style={{ objectFit: "cover" }}
            />
          </div>

          {/* Кнопка воспроизведения */}
          {!isLoading && !isPlaying && (
            <button
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-20"
              onClick={togglePlay}
            >
              <svg
                className="w-16 h-16 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}

          {/* Элементы управления видео */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent h-16 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end">
            <div className="p-2 w-full">
              <div className="w-full bg-gray-400 h-1 rounded-full overflow-hidden">
                {playerRef.current && (
                  <div
                    className="bg-blue-500 h-full"
                    style={{
                      width: `${
                        (playerRef.current.getCurrentTime() /
                          playerRef.current.getDuration()) *
                        100
                      }%`,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IphonePlayer;
